<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
    <path d="M7 7H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M8.5 10H11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M10 13H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TimelineIcon'
}
</script>

